import { AppState } from './../../../app.reducer';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalFileUploadService } from '../../../file-upload/components/global-file-upload.service';
import { MenuBarService } from './menu-bar.service';
import { MenuBarViewModel } from './menu-bar.view-model';
import { Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

@Component({
  selector: 'osn-cxb-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MenuBarService],
})
export class MenuBarComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();
  public menuItems$ = this.menuBarService.menuItems$;
  public readonly version = this.menuBarService.version;
  public readonly apiVersion$ = this.menuBarService.apiVersion$;
  public readonly showVersion = this.menuBarService.showVersion;
  public vm: MenuBarViewModel;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly menuBarService: MenuBarService,
    public readonly globalFileUploadService: GlobalFileUploadService,
    private readonly store: Store<{ router: RouterReducerState; app: AppState }>
  ) {}

  public ngOnInit(): void {
    this.menuBarService.vm$.pipe(takeUntil(this.onDestroy$)).subscribe((vm) => {
      this.vm = vm;
      this.cdr.detectChanges();
    });
    this.store
      .select((state: { router: RouterReducerState; app: AppState }) => state.router?.state?.url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((url) => {
        if (url?.startsWith('/root')) {
          this.menuItems$ = this.menuBarService.tenantIndependentMenuItems$;
        } else {
          this.menuItems$ = this.menuBarService.menuItems$;
        }
        this.cdr.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public onLoginClicked() {
    this.menuBarService.login();
  }

  public onLogoutClicked() {
    this.menuBarService.logout();
  }
}
